import { useAssetLibraryCompactLayout } from '../assetLibraryEmbedContext';
import {
  getAssetLibraryGridClassName,
  getAssetLibrarySkeletonCount,
} from '../assetLibraryGridLayout';
import { getAssetLibraryCardLayoutClasses } from './AssetLibraryCardShell';

export interface AssetLibraryLoadingProps {
  count?: number;
  gridClassName?: string;
  embedded?: boolean;
  /** Set to `aspect-square` when standing in for motion library results. */
  thumbnailAspectClass?: string;
}

export default function AssetLibraryLoading({
  count,
  gridClassName,
  embedded = false,
  thumbnailAspectClass = 'aspect-video',
}: AssetLibraryLoadingProps) {
  const compactFromContext = useAssetLibraryCompactLayout();
  const compact = embedded || compactFromContext;
  const { gapClass, paddingClass } = getAssetLibraryCardLayoutClasses(compact);
  const resolvedGridClassName =
    gridClassName ?? getAssetLibraryGridClassName(embedded);
  const resolvedCount = count ?? getAssetLibrarySkeletonCount(embedded);

  return (
    <div className={resolvedGridClassName}>
      {Array.from({ length: resolvedCount }).map((_, index) => (
        <div
          key={index}
          className={`flex flex-col ${gapClass} ${paddingClass} rounded-2xl`}
        >
          <div
            className={`bg-tertiary ${thumbnailAspectClass} animate-pulse rounded-lg`}
          />
          <div className="flex flex-col gap-2 px-2">
            <div className="bg-secondary h-5 w-3/4 animate-pulse rounded-lg" />
            <div className="bg-secondary h-4 w-1/2 animate-pulse rounded-lg" />
            <div className="bg-secondary h-4 w-2/5 animate-pulse rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}
